<template>
  <b-card v-if="!!option" id="page-whitelist-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title>
        <h2>
          {{ $t(getTitle()) }} {{ $t("pages.whitelist.title").toLowerCase() }}
        </h2>
      </b-card-title>
      <b-button type="button" variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('name'))" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="whitelist.nameContact"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('phone'))" label-for="phone">
                <vue-tel-input
                  inputId="phoneNumber"
                  name="phoneNumber"
                  v-model="whitelist.phoneNumber"
                  :disabled="!isSaveMode"
                  :mode="'international'"
                  defaultCountry="ve"
                  :disabledFetchingCountry="true"
                  :inputOptions="inputTelOption"
                  @open="onDropdownOpen(true)"
                  @close="onDropdownOpen(false)"
                >
                  <template v-slot:arrow-icon>
                    <span>{{ openTelInput ? "▲" : "▼" }}</span>
                  </template>
                </vue-tel-input>
              </b-form-group>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BForm,
  BAlert,
  BToast,
  BFormInvalidFeedback,
  BFormGroup,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

import {
  getWhitheList,
  createOrEditWhitheList,
  allWhitheListByCompany,
} from "@/@core/api/request/whitelist";

import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

const whitelist = {
  idWhiteList: null,
  guidCompany: null,
  nameContact: null,
  phoneNumber: "",
};

export default {
  components: {
    BAlert,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,

    BFormGroup,
    BFormInput,
    BForm,
    BToast,
    BFormInvalidFeedback,
    VueTelInput,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    isSaveMode: true,
    required,
    option: "",
    whitelist: Object.assign(whitelist),
    inputTelOption: {
      placeholder: "Ingrese un número de teléfono",
    },
    openTelInput: false,
  }),
  computed: {},

  created() {
    localize("es");
    this.initialize();
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.whitelist.guidCompany = guid;
    },
  },

  mounted() {},

  methods: {
    label(field) {
      return `pages.whitelist.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "whitelists" }).catch(() => {});
      }

      switch (this.option) {
        case 1:
          this.onCancel();
          this.whitelist.guidCompany =
            this.$store.state.appConfig.activeCompanyGuid;
          break;
        case 2:
        case 3:
          if (this.$route.params.idWhiteList === undefined) {
            router.push({ name: "whitelists" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          this.getWhitheList(this.$route.params.idWhiteList);
          break;
      }
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          showLoading();
          const idWhiteList =
            this.option === 1 ? null : this.whitelist.idWhiteList;
          createOrEditWhitheList(this.whitelist, idWhiteList)
            .then(() => {
              stopLoading();
              this.goBack();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", "Alerta error", error.message);
            });
        }
      });
    },

    getWhitheList(idWhiteList) {
      showLoading();
      getWhitheList(idWhiteList)
        .then((resp) => {
          const whitelist = _.get(resp, "data");
          this.whitelist = Object.assign(this.whitelist, {
            idWhiteList: whitelist.idWhiteList || null,
            guidCompany: whitelist.guidCompany || null,
            nameContact: whitelist.nameContact || null,
            phoneNumber: whitelist.phoneNumber || null,
          });
          stopLoading();
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.alertToast("danger", "Alerta error", error.message);
        });
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
    },

    onCancel() {
      Object.assign(this.whitelist, {
        idWhiteList: null,
        guidCompany: null,
        nameContact: null,
        phoneNumber: null,
      });
    },

    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },
    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
